import { render, staticRenderFns } from "./PharmacyUpsertForm.vue?vue&type=template&id=58807f84"
import script from "./PharmacyUpsertForm.vue?vue&type=script&lang=js"
export * from "./PharmacyUpsertForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports